import 'prismjs/themes/prism.css';
import './src/styles/global.scss';

import { Script, WrapPageElementBrowserArgs } from 'gatsby';
import RootLayout from './src/components/templates/RootLayout';

export function wrapPageElement(props: WrapPageElementBrowserArgs) {
  const { element, props: pageProps } = props;
  return (
    <RootLayout {...pageProps}>
      <Script id='gtm' dangerouslySetInnerHTML={{ __html: GTM_SCRIPT }} />

      {element}
    </RootLayout>
  );
}

const GTM_SCRIPT = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-TMDQ64PL');`;
